import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// Components
import Online from './components/Online.vue'
import Experience from './components/Experience.vue'
import Projects from './components/Projects.vue'
import Specifics from './components/Specifics.vue'
import Contact from './components/Contact.vue'

Vue.use(VueRouter)

const routes = [
  { path: '', component: Online },
  { path: '/experience', component: Experience },
  { path: '/projects', component: Projects },
  { path: '/stack', component: Specifics },
  { path: '/contact', component: Contact },
]

const router = new VueRouter({
  routes
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
